/* eslint-disable @typescript-eslint/no-explicit-any */
import { put } from '_core/config/api/Api';
import { IFinalResponse, InitApiType } from '_core/types';
import Definitions from '../Definitions';
import { UpdateMemberSensitiveDataTypes } from '../Types';

const definitions = Definitions.UpdateMemberSensitiveData;

const callPut = async (
  params: UpdateMemberSensitiveDataTypes.UpdateMemberSensitiveDataServiceRequestType,
): Promise<IFinalResponse> => {
  const init: InitApiType = {
    body: {
      ...params,
    },
  };
  return put(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};
const call = { put: callPut };

export default { call, definitions };
